import FilterContext from '@jetshop/core/components/Filters/FilterContext';
import React from 'react';
import styled from 'react-emotion';
import t from '@jetshop/intl';
import theme from '@jetshop/ui/utils/theme';
import ActiveListFilters from '@jetshop/ui/Filter/ActiveFilters';
import Checkbox from '@jetshop/ui/Checkbox';
import ListFilterFlyouts from '@jetshop/ui/Filter/FilterTypes/List/ListFilterFlyouts';

const StyledCheckboxList = styled('div')`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  label.no-result {
    opacity: 0.2;
    cursor: default;
    &:hover {
      input ~ span {
        background-color: #fff;
      }
    }
  }
  div,
  > label {
    width: 25%;
    display: flex;
    padding: 3px 10px;
    text-transform: uppercase;
    ${theme('below.md')} {
      width: 50%;
    }
  }
  span {
    height: 14px;
    width: 14px;
    margin-right: 0.3rem;
  }
  div:first-child {
    display: block;
    flex: none;
    margin-bottom: 2rem;
    text-align: center;
    width: 100%;
    h2 {
      text-transform: uppercase;
      font-size: 2.5rem;
      margin-bottom: 5px;
    }
    h3 {
      text-transform: uppercase;
      font-size: 1.2rem;
    }
  }
`;

const Filters = styled('div')`
  display: flex;
  flex-wrap: wrap;
  svg {
    width: 10px;
  }
  .standard {
    max-width: 20%;
    z-index: 999999999;
  }
`;
const StyledActiveListFilters = styled('div')`
  flex: 1 auto;
  width: 100%;
  display: flex;

  [data-channel='Eyewearstore'] & {
    margin-top: 0.5rem;
  }
  aside {
    width: auto;
    flex: 0 auto;
  }
  aside div button {
    background: #ebebeb;
    color: #000;

    label {
      display: none;
    }
    svg {
      width: auto;
    }
    svg use {
      fill: #000;
    }
  }
  aside > button {
    background: none;
    text-decoration: none;
    text-transform: uppercase;
    display: none;
  }

  button {
    margin-top: 0;
  }
`;

const ClearFilter = styled('span')`
  background: #ebebeb;
  color: #000;
  padding: 0.5rem;
  margin: 0.5rem;
  margin-top: 0;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
`;

export const CustomActiveList = ({ filters }) => {
  return (
    <StyledActiveListFilters>
      <ActiveListFilters filters={filters} />
      <FilterContext.Consumer>
        {filterProps => {
          if (filterProps.activeFilters.listFilters.length > 0) {
            return (
              <ClearFilter
                onClick={() => {
                  for (let i = 0; i < filterProps.activeFilters.listFilters.length; i++) {
                    const activeFilter = filterProps.activeFilters.listFilters[i];
                    setTimeout(function() {
                      filterProps.clearListFilter(activeFilter.id);
                    }, 5);
                  }
                }}
              >
                {t('Clear filter')}
              </ClearFilter>
            );
          }
        }}
      </FilterContext.Consumer>
    </StyledActiveListFilters>
  );
};

class CheckBoxList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: []
    };
  }

  componentDidMount() {
    if (this.props.defaultSelectedItems !== undefined) {
      this.setState({ selectedItems: this.props.defaultSelectedItems });
    } else if (this.state.selectedItems.length > 0) {
      this.setState({ selectedItems: [] });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.defaultSelectedItems !== prevProps.defaultSelectedItems) {
      if (this.props.defaultSelectedItems !== undefined) {
        this.setState({ selectedItems: this.props.defaultSelectedItems });
      } else if (this.state.selectedItems.length > 0) {
        this.setState({ selectedItems: [] });
      }
    }
  }

  updateFilter(item) {
    let items = this.state.selectedItems;
    let selected = -1;
    for (var i = 0; i < items.length; i++) {
      let selectedItem = items[i];
      if (item.value === selectedItem.value) {
        selected = i;
      }
    }
    if (selected > -1) {
      items.splice(selected, 1);
    } else {
      items.push(item);
    }
    this.setState({ selectedItems: items });
    this.props.onChange(items);
  }
  shouldBeChecked(item) {
    for (var i = 0; i < this.state.selectedItems.length; i++) {
      let selectedItem = this.state.selectedItems[i];
      if (item.value === selectedItem.value) {
        return true;
      }
    }
  }
  render() {
    const { items, name } = this.props;

    return (
      <StyledCheckboxList key="unique">
        <div>
          <h3>Filtrera på {name}</h3>
        </div>
        {items.map((item, index) => {
          let checked = this.shouldBeChecked(item) ? true : false;
          return (
            <div key={item.value}>
              <Checkbox
                className={item.resultCount === 0 && 'no-result'}
                type="checkbox"
                key={index}
                value={item.value}
                tabIndex={0}
                checked={checked}
                label={item.text}
                onChange={() => this.updateFilter(item)}
                disabled={item.resultCount === 0}
              />
            </div>
          );
        })}
      </StyledCheckboxList>
    );
  }
}

const CustomListFilter = ({ filters, className = '' }) => {
  const listFilters = filters.filter(
    filter => filter.__typename === 'ListFilter'
  );
  if (listFilters.length < 1) return null;

  return (
    <Filters>
      <FilterContext.Consumer>
        {filterProps =>
          listFilters.map(filter => {
            const selectedFilter = filterProps.activeFilters.listFilters.find(
              item => item.id === filter.id.split(':')[1]
            );

            const selectedItems =
              selectedFilter &&
              selectedFilter.values.map(val => ({ value: val }));
            const onChange = vals => {
              return filterProps.applyListFilter(filter.id, vals);
            };

            return (
              <CheckBoxList
                key={`check-${filter.id}`}
                items={filter.items}
                defaultSelectedItems={selectedItems}
                onChange={vals => onChange(vals)}
                className={className}
                name={filter.name}
              />
            );
          })
        }
      </FilterContext.Consumer>
      <CustomActiveList filters={filters} />
    </Filters>
  );
};

export default CustomListFilter;
